import React from 'react';
import TournamentStatsView from '../../scoring/pingpong/stats/views/TournamentStatsView';
import TournamentPickleballStatsView from '../../scoring/pickleball/stats/views/TournamentPickleballStatsView';

const isPickleball = (tournament) => {
  // API transforms sport_typea → sportType.sportName
  const name = tournament?.sportType?.sportName || tournament?.sport_typea?.sport_name || '';
  return name.toLowerCase() === 'pickleball';
};

const StatsTab = ({ tournament }) => {
  if (!tournament) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent" />
      </div>
    );
  }

  if (isPickleball(tournament)) {
    return (
      <TournamentPickleballStatsView
        tournamentId={tournament.id}
        tournament={tournament}
      />
    );
  }

  return (
    <TournamentStatsView
      tournamentId={tournament.id}
      tournament={tournament}
    />
  );
};

export default StatsTab;
